// extracted by mini-css-extract-plugin
module.exports = {"cardFooter":"card-footer_cardFooter__seJ7o"};